import { defineStore } from 'pinia'
import axios from 'axios'

export const useClubsStore = defineStore('clubs', {
  state: () => ({
    clubs: [],
    isLoading: false,
    error: null
  }),

  getters: {
    getClubById: (state) => {
      return (clubId) => state.clubs.find(club => club.id === clubId)
    }
  },

  actions: {
    // 取得 CSRF token
    getCsrfToken() {
      const token = document.querySelector('meta[name="csrf-token"]')
      return token ? token.getAttribute('content') : null
    },

    // 取得所有武場列表
    async getClubs() {
      try {
        this.isLoading = true
        this.error = null
        
        const response = await axios.get('/clubs.json', {
          headers: {
            'Accept': 'application/json'
          }
        })
        
        this.clubs = response.data
        return response.data
      } catch (error) {
        console.error('取得武場列表失敗:', error)
        this.error = error.response?.data?.error || '載入武場列表失敗'
        throw error
      } finally {
        this.isLoading = false
      }
    },

    // 加入武場（使用 GET 方法，因為 Rails 控制器會處理重導向）
    async joinClub(clubId) {
      try {
        // 直接導向到加入 URL，讓 Rails 處理邏輯和重導向
        window.location.href = `/clubs/${clubId}/join`
        return { success: true, message: '正在處理加入申請' }
      } catch (error) {
        console.error('加入武場失敗:', error)
        const errorMessage = '加入武場失敗'
        this.error = errorMessage
        throw new Error(errorMessage)
      }
    },

    // 離開武場（使用表單提交，因為需要 POST 請求）
    async leaveClub(clubId) {
      try {
        const csrfToken = this.getCsrfToken()
        
        // 創建隱藏表單來提交 POST 請求
        const form = document.createElement('form')
        form.method = 'POST'
        form.action = `/clubs/${clubId}/leave`
        form.style.display = 'none'
        
        // 添加 CSRF token
        const csrfInput = document.createElement('input')
        csrfInput.type = 'hidden'
        csrfInput.name = 'authenticity_token'
        csrfInput.value = csrfToken
        form.appendChild(csrfInput)
        
        // 提交表單
        document.body.appendChild(form)
        form.submit()
        
        return { success: true, message: '正在處理退出申請' }
      } catch (error) {
        console.error('退出武場失敗:', error)
        const errorMessage = '退出武場失敗'
        this.error = errorMessage
        throw new Error(errorMessage)
      }
    },

    // 清除錯誤狀態
    clearError() {
      this.error = null
    },

    // 重設 store 狀態
    reset() {
      this.clubs = []
      this.isLoading = false
      this.error = null
    }
  }
})